import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateFileTypeSaga } from "src/store/file-types/saga";
import { FileTypeDetailDto } from "src/store/file-types/type";
import { getModuleTypes } from "src/store/system/saga";
import { ModuleTypeDto } from "src/store/system/type";
import * as Yup from "yup";

const FileTypeEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: FileTypeDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [moduletypes, setModuleTypes] = useState<ModuleTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getModuleTypes({
          payload: {
            onSuccess: (message, payload) => {
              setModuleTypes(payload);
            },
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("FileType.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          ModuleTypeId: data.ModuleTypeId,
          TypeName: data.TypeName,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          TypeName: Yup.string().required(t("Validation.Required").toString()),
          ModuleTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
          Translates: Yup.array(
            Yup.object({
              TypeName: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "TypeName",
            label: t("FileType.TypeName").toString(),
          },
        ]}
        inputs={[
          {
            field: "ModuleTypeId",
            label: t("FileType.ModuleType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: moduletypes,
            },
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            updateFileTypeSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default FileTypeEditForm;
